import React from "react";
import ServiceCard from "./cart/ServiceCard";

function ServicesSolution({ servicesData, title, highlight, afterthat, description }) {
  return (
     <>
      <div className="our-service-section padding-container">
        <div className="page-wrapper">
          <div className="our-service-top">
            <h1>
              {title}
              <span style={{ color: "var(--orange-color)" }}>{highlight}</span>
              {afterthat}
            </h1>
            <p>{description}</p>
          </div>
        </div>
      </div>

      <div className="contact-info-section">
        <div className="page-cover">
          <div className="our-solutions">
            <div className="Grid-3-box">
              {servicesData.map((service, index) => (
                <ServiceCard
                  key={index}
                  title={service.title}
                  description={service.description}
                  image={service.image}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
   </>
  );
}

export default ServicesSolution;
